<template>
  <div>


    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap>
          <v-flex lg12>
            <p class="table_card__head--title">
              Creación de nuevo counter
            </p>
            <v-breadcrumbs class="breadcums">
              <v-icon slot="divider">chevron_right</v-icon>
              <v-breadcrumbs-item
                @click="$router.push({name: 'access'})"
                class="breadcums__option"
              >
                Resumen de accesos
              </v-breadcrumbs-item>
              <v-breadcrumbs-item
                @click="$router.push({name: 'counter_index'})"
                class="breadcums__option"
              >
                Counters
              </v-breadcrumbs-item>
              <v-breadcrumbs-item
                disabled
                class="breadcums__disable"
              >
                Crear counter
              </v-breadcrumbs-item>
            </v-breadcrumbs>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__body">
        <v-layout row wrap>
          <v-flex xs12 row>
            <v-form onSubmit="return false;" ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap
                style="background-color: #fff; padding: 0px;"
              >
              <v-flex xs5 style="padding: 8px">
                <v-text-field
                  v-model="counter.attributes.name"
                  label="Nombre"
                  required
                  placeholder="Nombre"
                  :rules="[rules.required, rules.name]"
                  counter="25"></v-text-field>
              </v-flex>
              <v-flex
                xs1
                style="padding: 8px">
              </v-flex>
              <v-flex
                xs5
                style="padding: 8px 0px">
                <v-text-field
                  v-model="counter.attributes.last_name"
                  label="Apellidos"
                  required
                  placeholder="Apellidos"
                  :rules="[rules.required, rules.name]"
                  counter="25"></v-text-field>
              </v-flex>

              <v-flex
                xs5
                style="padding: 8px">
                <v-text-field
                  v-model="counter.attributes.email"
                  label="Correo electrónico"
                  required
                  placeholder="Correo electrónico"
                  :rules="[rules.required, rules.email, rules.affair]"
                  counter="50"></v-text-field>
              </v-flex>
              <v-flex
                xs1
                style="padding: 8px">
              </v-flex>
              <v-flex xs5>
                <v-text-field
                  v-model="counter.attributes.rut"
                  style="margin-top:10px"
                  label="Cédula"
                  required
                  placeholder="Cédula"
                  @keypress="isRutValid($event)"
                  :rules="[rules.required, rules.affair,rules.rut]"
                  counter="20">
                </v-text-field>
              </v-flex>

              <v-flex xs5>
                <v-select
                style="margin-top:10px"
                label="Locación"
                :items="locationArray"
                item-text='name'
                item-value='id'
                v-model="counter.attributes.location_id"
                :rules="[rules.required]"
                ></v-select>
              </v-flex >
            <v-flex
                xs1
                style="padding: 8px">
              </v-flex>
              <v-flex xs5>
                <v-text-field
                  v-model="counter.attributes.password"
                  style="margin-top:10px"
                  label="Contraseña"
                  required
                  placeholder="Dígita tu contraseña"
                  :rules="[rules.required,rules.password]"
                  type="password">
                </v-text-field>
              </v-flex >
              <v-flex
                xs6
                style="padding: 8px">
              </v-flex>
              <v-flex xs5>
                <v-text-field
                  v-if="counter.attributes.password.length>=6"
                  v-model="confirmPassword"
                  style="margin-top:10px"
                  label="Confirmar contraseña"
                  required
                  placeholder="Repite tu contraseña"
                  :rules="[rules.required,rules.confirm_password]"
                  type="password">
                </v-text-field>
              </v-flex >

              <!-- <v-flex
                xs12
                style="padding: 8px">
                {{counter}}
              </v-flex> -->
              <!-- <v-flex
                xs12
                style="padding: 8px">
                <v-text-field
                  v-model="counter.attributes.title"
                  label="Título"
                  placeholder="Máximo 70 caracteres"
                  :rules="[rules.title]"
                  counter="70"></v-text-field>
              </v-flex>
              <v-flex
                xs8
                style="padding: 8px">
                <v-textarea
                  style="border:1px dashed #1976d2;padding:30px 20px 5px 10px "
                  v-model="counter.attributes.message"
                  label="Mensaje*"
                  :auto-grow="true"
                  rows="1"
                  outlined
                  placeholder="Escribe el contenido del mensaje"
                  :rules="[rules.required, rules.message]"></v-textarea>
              </v-flex>-->
            </v-layout>
            </v-form>
          </v-flex>



          <!--<v-flex xs12 style="align-content:center;margin-top:30px;justify-content:space-between;display:flex" >
              <v-btn
                outline
                color="red"
                style="width: 20%"
                @click="$router.push({name: 'counter_index'})"
                >Volver</v-btn>
            </v-flex>-->

        </v-layout>
      </div>
      <div class="table_card__footer">
        <button
          type="button"
          class="faccess_button"
          @click="sendCounter()"
          :disabled="!valid || !counter.attributes.name|| !counter.attributes.last_name|| !counter.attributes.email|| !counter.attributes.rut ||
                    !counter.attributes.location_id|| !counter.attributes.password|| !confirmPassword "
        >
          Enviar y guardar counter
        </button>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  data(){
    return{
      counter: {
        attributes: {
          name:'',
          last_name: '',
          rut:'',
          email:'',
          password:'',
          location_id:null,
          company:this.getCompany().id
        }
      },
      locationArray:[],
      confirmPassword:'',
      rules: {
          required: value => value.length>0 || 'Este campo es obligatorio',
          name: value =>{
            if(value.length>=3){
                return  value.length <= 25 || 'Máximo 25 caracteres'
            }else{
                return value.length >= 3  || 'Mínimo 3 caracteres'
            }},
          affair: value => value.length <= 50 || 'Máximo 50 caracteres',
          email: value => {
                if(value.length > 0) {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || 'E-mail incorrecto';
                }
            },
          rut: value => {
                if(value.length >20){return 'El rut no debe tener más de 20 caracteres' }else if(value.length > 6) {return !isNaN(value.substring(0,value.length-1)) || 'Formato de Rut incorrecto'}else{return 'El Rut debe tener al menos 7 caracteres'}},
          password: value => (value.length <= 50 && value.length>=6) || 'La contraseña debe tener al menos 6 dígitos',
          confirm_password: value => ( (value.length <= 50 && value.length>=6)&& value==this.counter.attributes.password) || 'Las contraseñas no coinciden',
      },
      valid: false
    }
  },
  props:["users","unregistered_users","comunication"],
  created() {
    this.fetchAllLocations()
  },
  computed: {

  },
  methods: {
    fetchAllLocations() {
      const data = { company: { id: this.getCompany().id } }
      const headers = {
        "X-Device-ID": this.getDeviceId(),
        "Authorization": 'Bearer ' + this.getUserToken()
      }
      const allLocations = []
      const loadPage = (page) => {
        return this.$http.post('locations/company', { data: this.encrypt(data).toString() }, {
          headers,
          params: { page }
        }).then((response) => {
          const body = response.body || {}
          const locations = body.data || []
          const meta = body.meta || {}
          const totalPages = Number(meta.pages || 1)
          allLocations.push(...locations)
          if (meta.authentication_token) {
            this.checkToken(meta.authentication_token)
          }
          if (page < totalPages) {
            return loadPage(page + 1)
          }
          this.locationArray = allLocations.map((elem) => ({ id: elem.id, name: elem.attributes.name }))
        })
      }

      return loadPage(1).catch((response) => {
        if (response && response.body && response.body.meta && response.body.meta.authentication_token) {
          this.checkToken(response.body.meta.authentication_token)
        }
      })
    },
    isRutValid(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && evt.key.toUpperCase()!="K") {
            evt.preventDefault();;
        } else {
            return true;
        }
    },

    sendCounter(){
      String.prototype.capitalize = function() {
        return this.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
      };
      var send_counters=[];
      this.counter.attributes.name=this.counter.attributes.name.capitalize()
      this.counter.attributes.last_name=this.counter.attributes.last_name.capitalize()
      this.counter.attributes.rut=this.counter.attributes.rut.toUpperCase()
      console.log("ENVIANDO COUNTER")
      console.log(this.counter.attributes)

      try {
        console.log(this.counter)
        this.$http.post('counters',{
          data: this.encrypt(this.counter).toString()
        },{
          headers: {
            "X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()
          }
        }).then(function(response){
          console.log(response);
          this.$router.push({name: 'counter_index'})



          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          console.log(response);
        })
      } catch (e) {
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
        alert(e.message)
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/access/counter/NewCounter.vue